<template>
    <el-dialog
      class="detail-info-dia"
      title="创建预录取通道"
      :visible.sync="isShow"
      :close-on-click-modal="false"
      :width="dw"
      
      top="12vh">
        <vue-scroll :ops="vuescrollOpt">
        <el-form :model="credential" label-width="110px" class="blackListForm" :rules="formRules" ref="form" style="max-height:625px">
            <el-form-item label="截止日期" prop="end_date">
                <el-date-picker
                  type="date"
                  v-model="credential.end_date"
                  :picker-options="recommendEndDateRangeOpt"
                  :clearable="true"
                  value-format="yyyy-MM-dd"
                  placeholder="选择截止日期"
                  style="width:100%"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="备注" >
                <el-row style="position: relative">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 7}"  maxlength="200" style="width: 100% " placeholder="请输入备注" v-model="credential.info"></el-input>
                    <span class="num" style="position: absolute;bottom: -10px;right: 10px">{{credential.info.length}}/200</span>
                </el-row>
            </el-form-item>
            <div style="margin-bottom:22px">
                <label style="margin-right:20px"> 发送通知短信</label>
                <el-radio v-model="credential.is_send_sms" label="1">发送</el-radio>
                <el-radio v-model="credential.is_send_sms" label="0">不发送</el-radio>
            </div>
            <el-form-item label="班级群二维码">
                <el-upload
                  ref="uploadFile"
                  action="/api/enroll/upload_enroll_file.json"
                  :file-list="credential.files"
                  :headers="fileUpHeaders"
                  :data="fileUpParam"
                  :before-upload="beforeUpload"
                  :on-progress="isUping"
                  :on-error="uploadError"
                  :on-success="uploadSuccess"
                  :on-remove="fileRemove"
                  :on-exceed="
                    (files, fileList) =>
                      handleUploadExceed(
                        files,
                        fileList,
                      )
                  "
                  :limit="1"
                >
                    <el-button type="primary">点击上传</el-button>
                    <div slot="tip" class>只能上传1个jpg/jpeg/png文件，且文件大小不能超过20M</div>
                </el-upload>
            </el-form-item>
            <div class="btns">
                <el-button type="primary" @click="sureSubmit" :loading="loading" :disabled="loading">确定</el-button>
                <el-button type="danger" @click="cancel">取消</el-button>
            </div>
        </el-form>
        </vue-scroll>
    </el-dialog>
</template>

<script>
  import { create_pre_admission } from "@/api/system_manager/api";
  import { storageData } from "@/assets/js/storage";
  import createScrollOpt from "@/assets/js/vuescrollOption";
  export default {
    name: "addPreAdmission",
    data(){
      return{
        loading:false,
        notEdit:false,
        submitDisabled: false,
        vuescrollOpt: createScrollOpt(),
        fileUpHeaders: { "X-Token": storageData.getToken(),"X-UserType":storageData.getUserType() },
        fileUpParam: {},
        credential:{
          end_date:'',
          is_send_sms:"1",
          files: [],
          info:''
        },
        formRules:{
          end_date:[
            {required: true, message: '请选择截止日期', trigger: 'change'},
          ],
          info:[
            {required: true, message: '请填写备注说明', trigger: 'blur'},
          ],
        }
      }
    },
    created(){
      if (Object.keys(this.Info).length>0){
        Object.assign(this.credential,this.Info)
        this.notEdit=true
      }
    },
    props:{
      showAddDialog:{
        type:Boolean,
        required:true,
        default: false,
      },
      Info:{
        type:Object,
        required :false
      },
      c_id:{
        type:Number,
        required :true
      },
      last_date:{
        type:Number,
        required :true
      },
      dw:{
        default:'500px',
        required:false,
      }
    },
    computed: {
      isShow: {
        get(){
          return this.showAddDialog;
        },
        set(bool){
          // 参数1：是否显示弹窗
          // 参数2：是否点击确定按钮
          this.$emit("hideTips", bool, false);
        }
      },
      recommendEndDateRangeOpt() {
        const last= this.last_date - 2*24*60*60*1000
        return {
          disabledDate: time => {
            return time.getTime() < new Date().setHours(0, 0, 0, 0) || time.getTime()>last;
          }
        };
      },
    },
    methods:{
      handleUploadExceed(files, fileList, fileListName, fileFlag) {
        this.$message.warning("上传文件超过最大允许数目！");
      },
      beforeUpload(file) {
        if (file.size > 20 * 1024 * 1024) {
          this.$message.error("文件大小不能超过20M!");
          return false;
        }
        if (!/^.*\.(jpg|jpeg|png|)$/i.test(file.name)) {
          this.$message.error("请上传 jpg jpeg png 格式的文件!");
          return false;
        }
        let param = {
          document: file
        };
        for (const key in param) {
          if (param.hasOwnProperty(key)) {
            this.$set(this.fileUpParam, key, param[key]);
          }
        }
      },
      isUping() {
        this.submitDisabled = true;
      },
      uploadError() {
        this.submitDisabled = false;
      },
      uploadSuccess(res) {
        this.submitDisabled = false;
        if (Number(res.status) === 0) {
          this.credential.files.push({ url: res.result.document_url, name: res.result.document_name })
        } else {
          this.$nextTick(() => { });
          this.$message.error(res.msg);
        }
      },
      fileRemove(file, fileList) {
        this.credential.files = fileList;
      },
      cancel(){
        this.isShow=false;
      },
      sureSubmit(){
        this.$refs["form"].validate((valid) => {
          if (valid){
            if(this.credential.files.length===0){
              this.$message.error('请上传一个文件')
              return
            }
            const subData ={
              end_time:this.credential.end_date,
              remark:this.credential.info,
              is_send_sms:Number(this.credential.is_send_sms),
              c_id:this.c_id,
              document_url:this.credential.files[0].url
            }
            console.log(subData)
            create_pre_admission(subData).then(res=>{
              if (res.data.status===0){
                this.loading=false;
                this.$emit("hideTips", false, true);
              }else{
                this.$message.error(res.data.msg);
                this.loading=false
              }
            }).catch(error=>{
              this.loading=false
            })
          } else{
            this.$message.error('请填写所有带*号的必填项')
          }
        })
        
      }
    },
    components:{
      "image-up": () => import("@/components/UpImage/UpImage"),
    }
  }
</script>

<style scoped lang="stylus">
    .blackListForm
        padding-right 20px
        .btns
            display flex
            justify-content: center
    .el-dialog__body{
        padding-right: 0;
    }
</style>
